import { generateId } from '@freelancer/datastore/testing/helpers';
import type { ReferralTokenAjaxData } from './referral-token.backend-model';

export function generateReferralTokenObject(): ReferralTokenAjaxData {
  return {
    encoded_data: generateId().toString(),
  };
}
